import { GridRow } from '../services/dto/grid-row';
import { RowType } from '../services/dto/row-type';

/** Hierarchy CSS classes shared by both tree grids; matching styles in `_tree-hierarchy.scss`. */
export function getTreeRowClasses(data: GridRow | null | undefined, isLastChild = false): string[] {
  const classes: string[] = [];
  if (!data) {
    return classes;
  }

  if (data.hidden) {
    classes.push('row-hidden');
  }

  if (Array.isArray(data.compositionPath)) {
    const depth = Math.min(data.compositionPath.length + 1, 9);
    classes.push(`row-depth-${depth}`);

    if (data.rowType === RowType.Chapter) {
      classes.push(`row-chapter-depth-${depth}`);
    }

    if (data.rowType === RowType.Comment) {
      classes.push('row-comment');
    }

    if (data.parentId && isLastChild) {
      classes.push('row-last-child');
    }
  }

  return classes;
}
